/*
 * Sorts a list like [1, 4, '8x12', '8x8', '4x8', '8x2', 24]
 * to
 * [1, 4, 24, '8x2', 4x8', '8x8', '8x12']
 * - integer values first
 * - MxN is sorted N ascending, M ascending */ 

export default function (firstElement, secondElement) {
  let firstElementValueObject = { weigh: null, small: null, type: null}
  if (firstElement.indexOf('x') >= 0) {
    firstElementValueObject.weight = parseInt(firstElement.split('x')[1])
    firstElementValueObject.small = parseInt(firstElement.split('x')[0])
    firstElementValueObject.type = 'composedValue'
  } else {
    firstElementValueObject.weight = 0
    firstElementValueObject.small = parseInt(firstElement)
    firstElementValueObject.type = 'intValue'
  }

  let secondElementValueObject = { weigh: null, small: null, type: null}
  if (secondElement.indexOf('x') >= 0) {
    secondElementValueObject.weight = parseInt(secondElement.split('x')[1])
    secondElementValueObject.small = parseInt(secondElement.split('x')[0])
    secondElementValueObject.type = 'composedValue'
  } else {
    secondElementValueObject.weight = 0
    secondElementValueObject.small = parseInt(secondElement)
    secondElementValueObject.type = 'intValue'
  }

  if (firstElementValueObject.type === 'intValue' && secondElementValueObject.type === 'intValue') {
    if (firstElementValueObject.small < secondElementValueObject.small) return -1
    if (firstElementValueObject.small === secondElementValueObject.small) return 0
    if (firstElementValueObject.small > secondElementValueObject.small) return 1
  }

  if (firstElementValueObject.type === 'intValue' && secondElementValueObject.type === 'composedValue') {
    return -1
  }

  if (firstElementValueObject.type === 'composedValue' && secondElementValueObject.type === 'intValue') {
    return 1
  }

  if (firstElementValueObject.type === 'composedValue' && secondElementValueObject.type === 'composedValue') {
    if (firstElementValueObject.weight < secondElementValueObject.weight) return -1
    if (firstElementValueObject.weight === secondElementValueObject.weight) {
      if (firstElementValueObject.small < secondElementValueObject.small) return -1
      if (firstElementValueObject.small === secondElementValueObject.small) return 0
      if (firstElementValueObject.small > secondElementValueObject.small) return 1
    }
    if (firstElementValueObject.weight > secondElementValueObject.weight) return 1
  }

  return 0
}